'use client';

import { MOBILE_MENU_ROW_CLASS } from '../../lib/header-constants';
import { useNavbarContext } from './context';
import type { NavDropdownItem } from '../../types/navigation';

interface HeaderMobileDropdownListProps {
  items: NavDropdownItem[];
  onClose: () => void;
}

const HeaderMobileDropdownList = ({
  items,
  onClose,
}: HeaderMobileDropdownListProps) => {
  const { onNavClick } = useNavbarContext();

  return (
    <ul className="space-y-0.5">
      {items.map((item) => (
        <li key={item.label}>
          <a
            className={MOBILE_MENU_ROW_CLASS}
            href={item.href}
            onClick={() => {
              onNavClick?.({ href: item.href, label: item.label, url: item.href });
              onClose();
            }}
          >
            {item.label}
          </a>
        </li>
      ))}
    </ul>
  );
};

export default HeaderMobileDropdownList;
